import { Avatar, Box, Button, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TThirdPartyApp } from '../../shared/types/thirdParty.type'
import { isEmpty, isNull } from 'lodash'
import { Icon } from '@iconify/react'
import { useAuth } from '../../hooks/useAuth'
import { LoadingButton } from '@mui/lab'

function ThirdPartyApps() {
    const { updateThirdParty, thirdPartyUpdating } = useAuth()
    const thidPartyApps = useSelector<RootState>((state) => state.user.user?.third_party_access_requests) as TThirdPartyApp[]


    const acceptedApps = useMemo(() => {
        return thidPartyApps.filter(app => app?.activation_date && !app.revocation)
    }, [thidPartyApps])

    const pendingApps = useMemo(() => {
        return thidPartyApps.filter(app => !app?.activation_date)
    }, [thidPartyApps])

    if (isEmpty(acceptedApps) && isEmpty(pendingApps)) {
        return <></>
    }

    return (
        <Card>
            <CardContent>
                <Typography variant='h6' color={'white'} mb={2}>{t('thirdPartyApi:thirdPartyApplications')}</Typography>


                <Stack spacing={1}>
                    {
                        !isEmpty(acceptedApps) &&
                        <>
                            <Typography variant='body2'>{t('thirdPartyApi:acceptedRequests')}</Typography>
                            <Divider></Divider>
                            <Stack spacing={1}>
                                {
                                    acceptedApps.map(app => (
                                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} flexWrap={'wrap'} gap={2}>
                                            <Box display={'flex'}  gap={2} alignItems={'center'}>
                                                <Avatar sx={{ borderRadius: 1 }} src={app.third_party_api_user?.path_logo}>
                                                </Avatar>
                                                <Typography variant='subtitle2'>
                                                    <span dangerouslySetInnerHTML={{ __html: t('thirdPartyApi:hasAccessToYourData', { name: app.third_party_source_identifier }) }}></span>
                                                </Typography>
                                            </Box>
                                            <LoadingButton onClick={() => { updateThirdParty(app.id, { active: false }) }} loading={thirdPartyUpdating} startIcon={<Icon icon={'ant-design:disconnect-outlined'}></Icon>} variant='contained' color='error'>{t('thirdPartyApi:revokeAccess')}</LoadingButton>
                                        </Box>
                                    ))
                                }
                            </Stack>
                        </>
                    }
                    {
                        !isEmpty(pendingApps) &&
                        <>
                            <Typography variant='body2'>{t('thirdPartyApi:pendingRequests')}</Typography>
                            <Divider></Divider>
                            <Stack mt={2} spacing={1}>
                                {
                                    pendingApps.map(app => (
                                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                            <Box display={'flex'} gap={2} alignItems={'center'}>
                                                <Avatar sx={{ borderRadius: 1 }} src={app.third_party_api_user?.path_logo}>
                                                </Avatar>
                                                <Typography variant='subtitle2'>
                                                    <span dangerouslySetInnerHTML={{ __html: t('thirdPartyApi:requestsAccessToYourData', { name: app.third_party_source_identifier }) }}></span>
                                                </Typography>
                                            </Box>

                                            <Box display={'flex'} gap={1} alignItems={'center'}>
                                                <LoadingButton loading={thirdPartyUpdating} onClick={() => { updateThirdParty(app.id, { active: false }) }} variant='contained' color='error'>{t('thirdPartyApi:denyRequest')}</LoadingButton>
                                                <LoadingButton loading={thirdPartyUpdating} onClick={() => { updateThirdParty(app.id, { active: true }) }} sx={{ color: 'white' }} variant='contained' color='success'>{t('thirdPartyApi:acceptRequest')}</LoadingButton>
                                            </Box>
                                        </Box>
                                    ))
                                }
                            </Stack>
                        </>
                    }

                </Stack>
            </CardContent>
        </Card>
    )
}

export default ThirdPartyApps